import { describeStock, SolitaireBoard } from '../components/SolitaireBoard.js';
import { useStore } from '../store.js';
import { SoloRoom } from './SoloRoom.js';

/** Klondike at the table: the shared patience screen, wearing its board. */
export function SolitaireRoom() {
  const view = useStore((s) => s.solitaire);

  if (!view) {
    return (
      <main className="game">
        <p className="game__loading">Dealing…</p>
      </main>
    );
  }

  return (
    <SoloRoom
      name="Solitaire"
      phase={view.phase}
      moveNumber={view.moveNumber}
      status={describeStock(view.stockCount, view.redealsRemaining)}
      board={<SolitaireBoard />}
      stuckTitle="No moves left"
      stuckBody="Nothing on the board will move and the stock cannot help. That one was not winnable from here."
    />
  );
}
